import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
const TargetAudienceSection = lazy(() => import('./components/TargetAudienceSection').then(m => ({
  default: m.TargetAudienceSection
})));
const UniqueMechanismSection = lazy(() => import('./components/UniqueMechanismSection').then(m => ({
  default: m.UniqueMechanismSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const AuthorSection = lazy(() => import('./components/AuthorSection').then(m => ({
  default: m.AuthorSection
})));
const CTASection = lazy(() => import('./components/CTASection').then(m => ({
  default: m.CTASection
})));
const HowItWorksSection = lazy(() => import('./components/HowItWorksSection').then(m => ({
  default: m.HowItWorksSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TransformationSection = lazy(() => import('./components/TransformationSection').then(m => ({
  default: m.TransformationSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchaseNotifications = lazy(() => import('./components/PurchaseNotifications').then(m => ({
  default: m.PurchaseNotifications
})));
function SectionSkeleton() {
  return <div className="w-full py-24 bg-[#0D002B] animate-pulse" aria-hidden="true" data-id="element-0" data-mp="38li7lebna3n2" />;
}
const waves = {
  W1: () => <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-1" data-mp="3dm5ylzzvikha">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-2" data-mp="nuhh6fb985sp">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#110038" data-id="element-3" data-mp="swqajcs1h9vc" />
      </svg>
    </div>,
  W2: () => <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-4" data-mp="d2l9h7r2ob2y">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-5" data-mp="86w58r43y60b">
        <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V0H1200V30.36C1132.19,53.44,1055.71,74.35,985.66,92.83Z" fill="#0D002B" data-id="element-6" data-mp="3gj1qa19fol00" />
      </svg>
    </div>,
  W3: () => <div className="w-full overflow-hidden leading-none bg-[#110038]" data-id="element-7" data-mp="3limqsg4951eu">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-8" data-mp="2xt27tx83m45k">
        <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V0H1200V30.36C1132.19,53.44,1055.71,74.35,985.66,92.83Z" fill="#0D002B" data-id="element-9" data-mp="18e1bbp26nwm5" />
      </svg>
    </div>,
  W4: () => <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-10" data-mp="13eewxcamcabr">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-11" data-mp="13clr1z7txu4t">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#110038" data-id="element-12" data-mp="1w3vj3s7nauzj" />
      </svg>
    </div>,
  W5: () => <div className="w-full overflow-hidden leading-none bg-[#110038]" data-id="element-13" data-mp="6nw59xt30hdk">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-14" data-mp="6qs3zocr7a32">
        <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V0H1200V30.36C1132.19,53.44,1055.71,74.35,985.66,92.83Z" fill="#0D002B" data-id="element-15" data-mp="qxfbe0ehnln1" />
      </svg>
    </div>,
  W6: () => <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-16" data-mp="c9amufsr8fwc">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-17" data-mp="19vrjditnyph1">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#110038" data-id="element-18" data-mp="14y836ddeo2mg" />
      </svg>
    </div>,
  W7: () => <div className="w-full overflow-hidden leading-none bg-[#110038]" data-id="element-19" data-mp="3koucl4u7vg6n">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-20" data-mp="3glxz1sjjaa9k">
        <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V0H1200V30.36C1132.19,53.44,1055.71,74.35,985.66,92.83Z" fill="#0D002B" data-id="element-21" data-mp="1w5zy8e7pkwlg" />
      </svg>
    </div>,
  W8: () => <div className="w-full overflow-hidden leading-none bg-[#0D002B]" data-id="element-22" data-mp="29xefoglywpqe">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="block w-full h-[50px] md:h-[100px]" data-id="element-23" data-mp="2etv47bx2x640">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#110038" data-id="element-24" data-mp="2jw41gkgziubx" />
      </svg>
    </div>
};
export function App() {
  useEffect(() => {
    document.title = 'Rescate Clave de Paz | Salva tu relación';
    const meta = document.querySelector('meta[name="description"]');
    const content = 'Descubre el método práctico para reconstruir la comunicación, sanar heridas y blindar tu pareja contra las crisis financieras y el agotamiento mental.';
    if (meta) meta.setAttribute('content', content);else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'description';
      newMeta.content = content;
      document.head.appendChild(newMeta);
    }
    // Preconnect CDN
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = 'https://cdn.magicpatterns.com';
    document.head.appendChild(link);
    // Pixel diferido — no bloquea render, pero el stub queueing en pixel.ts
    // garantiza que los clicks rápidos también se trackeen.
    setTimeout(() => {
      import('./utils/pixel').then(({
        initPixel
      }) => initPixel());
    }, 1500);
  }, []);
  const {
    W1,
    W2,
    W3,
    W4,
    W5,
    W6,
    W7,
    W8
  } = waves;
  return <div className="w-full min-h-screen bg-[#110038] text-white font-sans" data-id="element-25" data-mp="2yiw3p9rgl4b7">
      {/* Marquee Urgency Banner — sticky top */}
      <div className="sticky top-0 z-50 w-full bg-[#ffa605] text-black py-2.5 overflow-hidden shadow-md" data-id="element-26" data-mp="3i4egb2x356h8">
        <div className="flex whitespace-nowrap animate-marquee" data-id="element-27" data-mp="3n0n392hiy3yy">
          {[...Array(4)].map((_, i) => <span key={i} className="text-sm font-bold tracking-wide inline-flex items-center gap-2 px-8" data-id="element-28" data-mp="387tbahl2fvde" data-mpi={i}>
              ⏳ OFERTA POR TIEMPO LIMITADO:&nbsp;
              <span className="text-[#c0392b]" data-id="element-29" data-mp="2zbakbaweahjg">53% OFF</span>
              &nbsp;—&nbsp;Precio normal&nbsp;
              <span className="line-through opacity-60" data-id="element-30" data-mp="2pez6ggh5pjmw">$24.999</span>
              &nbsp;→ HOY&nbsp;
              <span className="text-[#057a01] font-extrabold" data-id="element-31" data-mp="2ue20z6zig7gm">$11.749 ARS</span>
              &nbsp;—&nbsp;⚡ Al llegar a cero, el precio vuelve a $24.999
            </span>)}
        </div>
      </div>

      <HeroSection data-id="element-32" data-mp="2kfmly2drconh" />

      <Suspense fallback={<SectionSkeleton data-id="element-34" data-mp="2kekyszjgwbpe" />} data-id="element-33" data-mp="2kg4eanxauiq4">
        <W1 data-id="element-35" data-mp="2khyxnxsxa2s3" />
        <BonusSection data-id="element-36" data-mp="30vdjo8fiwx42" />
        <W2 data-id="element-37" data-mp="30vx2drczzpj5" />
        <UniqueMechanismSection data-id="element-38" data-mp="30uc7u1qoo6la" />
        <W3 data-id="element-39" data-mp="30ulxfo7tgbqg" />
        <TargetAudienceSection data-id="element-40" data-mp="30t15858z54vr" />
        <W4 data-id="element-41" data-mp="2vvr8s5n63syf" />
        <AuthorSection data-id="element-42" data-mp="2vxc1rqtu33u6" />
        <W5 data-id="element-43" data-mp="2vwtvs2hddb92" />
        <TransformationSection data-id="element-44" data-mp="2vu7q68e1h5th" />
        <W6 data-id="element-45" data-mp="2qwxtq8s8ftw5" />
        <CTASection data-id="element-46" data-mp="2qwel5ioh2hus" />
        <W7 data-id="element-47" data-mp="2qvwfjvfx6ra7" />
        <HowItWorksSection data-id="element-48" data-mp="2qvmridefqu75" />
        <W8 data-id="element-49" data-mp="2qz0ot788sd7q" />
        <GuaranteeSection data-id="element-50" data-mp="2lyd1own4wgis" />
        <W1 data-id="element-51" data-mp="2lx31o1wq0y9i" />
        <FAQSection data-id="element-52" data-mp="2lxbexuwra5l8" />
        <W2 data-id="element-53" data-mp="2m07cvj8lsu9o" />
        <Footer data-id="element-54" data-mp="2m0h2h5pqkzeu" />
        <PurchaseNotifications data-id="element-55" data-mp="2hw9ejar3rnho" />
      </Suspense>
    </div>;
}